
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import { AuthEnum } from '@/services/permission.service';
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';

@Component({})
export default class PartialRefoundPopover extends Vue {
  clicked = false;

  AuthEnum = AuthEnum;

  visible = false;

  @Ref('formRef')
  formRef!: FormModel;

  @Prop({
    default: '',
  })
  orderNo!: string;

  @Prop({
    default: {},
  })
  payPrice!: any;

  formData = {
    amount: '',
    reason: '',
    part: undefined,
  };

  labelCol = { span: 4 };
  wrapperCol = { span: 14 };
  rules = {
    part: [{ required: true, message: '请选择退款类型' }],
    amount: [
      { required: true, message: '请输入退款金额' },
      {
        validator: (rule: any, value: any, callback: any) => {
          if (value < 0.01) {
            callback(new Error('退款金额不能小于0'));
          } else if (value > this.payPrice) {
            callback(new Error('退款金额不能大于订单金额'));
          } else {
            callback();
          }
        },
      }],
    reason: [{ required: true, message: '请输入退款原因' }],
  };

  @lazyInject(CarService)
  carService!: CarService;

  modelClick() {
    this.visible = true;
  }

  changePart() {
    if (this.formData.part === 0) {
      this.formData.amount = this.payPrice;
    } else {
      this.formData.amount = '';
    }
  }

  handleClickChange(visible: boolean) {
    this.clicked = visible;
  }

  handleClick() {
    this.formRef.resetFields();
    this.visible = false;
  }

  /** 退款确认 */
  async refund(id: string, data: any) {
    const params = Object.assign(data, { order_no: id });
    const res = await this.carService.postShopOrderRefund(params);
    if (!res) {
      return;
    }
    this.$message.success(res);
    this.clicked = false;
    this.visible = false;
    this.$emit('refresh', true);
  }

  handleOk() {
    this.formRef.validate((valid) => {
      if (valid) {
        this.$confirm({
          title: '操作确认',
          content: `退款金额为${this.formData.amount}元,确认操作退款吗?`,
          onOk: async () => {
            await this.refund(this.orderNo, this.formData);
          },
          onCancel() { },
          class: 'test',
        });
      }
    });
  }
}
